export default __webpack_public_path__ + "static/media/bank-mastercard-square.ce969e25.svg";